// Block Media's scroll-in fade (block-media.css): the server renders the media visible (no
// data-scroll-state), so it's shown even if this script never runs (main.js blocked or failing
// to load). Once components.css is applied, the blocks still below the screen are set to "leave"
// here, and scroll-reveal.ts fades them in ("entered") as they scroll into view. A block already
// in view at that point is just shown - it never goes hidden and fades back in.

export function initBlockMedia(): void {
    document.querySelectorAll<HTMLElement>(".block-media[data-scroll-reveal]").forEach((block) => {
        if (!block.dataset.scrollState && block.getBoundingClientRect().top >= window.innerHeight) {
            block.dataset.scrollState = "leave";
        }
    });
}
